import StartDeliverables from "./StartDeliverables";
import StartFAQ from "./StartFAQ";
import StartFinalCTA from "./StartFinalCTA";
import StartHero from "./StartHero";
import StartProcess from "./StartProcess";
import StartProjectForm from "./StartProjectForm";
import StartWhyOglitz from "./StartWhyOglitz";

export default function StartProject() {
  return (
    <>
      <StartHero />
      <StartWhyOglitz />
      <StartProcess />
      <StartDeliverables />
      <StartProjectForm />
      <StartFAQ />
      <StartFinalCTA />
    </>
  );
}
